import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getFeedbacksState = (state: RootState) => state.feedbacks;

export const feedbackSelectors = {
  getFeedbacks: createSelector(
    getFeedbacksState,
    (feedbacksState) => feedbacksState.feedbacks,
  ),

  getFeedbacksLoading: createSelector(
    getFeedbacksState,
    (feedbacksState) => feedbacksState.isLoading,
  ),

  getFeedbackDetail: createSelector(
    getFeedbacksState,
    (feedbacksState) => feedbacksState.feedbackDetail.data,
  ),

  getFeedbackDetailLoading: createSelector(
    getFeedbacksState,
    (feedbacksState) => feedbacksState.feedbackDetail.isLoading,
  ),
};
